export const ALERT_TYPE_OPTIONS = [
  { value: 'low_in_stock_alert', label: 'Low in stock' },
  { value: 'back_in_stock_alert', label: 'Back in stock' },
  { value: 'sale_alert', label: 'Sale' },
]
